export default "__VITE_ASSET__CwDWMmfF__"